import React, { useEffect } from 'react'
import config from 'constants/aol/config'
import { intersection, isEmpty } from 'libraries/lodash'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import NotFound from 'components/NotFound'
import Forbidden from 'components/shared/Forbidden'
import Delayed from 'components/Delayed'

const AolAccess = (props) => {
  const {
    children,
    pageId,
    aol,
    availableAol,
    controller,
    isLogged,
    pages,
    aolConfigLoaded,
    setAolName,
    setAolConfig,
    setPlaceHoldersHideOverride,
    setPageParameters,
    accessRoles
  } = props

  useEffect(() => {
    if (!aolConfigLoaded) {
      setAolConfig(config)
    } else {
      const isValidAol = availableAol.some(validAol => validAol.urlFragment === aol)
      setAolName(isValidAol ? aol : '')
    }
  }, [aolConfigLoaded, setAolConfig, availableAol, aol, setAolName, pageId])

  useEffect(() => {
    setPlaceHoldersHideOverride(!pages[controller])
  }, [pages, controller])

  useEffect(() => {
    const pageRules = pages[controller]
    if (pageRules) {
      setPageParameters(pageRules.parameters || null)
    }
  }, [pages, controller])

  if (
    isLogged === RESPONSE_PENDING ||
    (isLogged && isEmpty(accessRoles))
  ) { // assume that the user is still loading in
    return null
  }

  const pageRules = pages[controller]

  if (!pageRules) { // the page map returns nothing if its not set in the config for that AoL
    // a bit of a hack
    // delay showing 404 as the rules for an aols pages may not have been added to pageRules yet
    return (
      <Delayed delay={50}>
        <NotFound />
      </Delayed>
    )
  }

  const { availableToRoles: pageRoleAccess } = pageRules

  const userHasAccess = !isLogged ||
    isEmpty(pageRoleAccess) ||
    !isEmpty(intersection(pageRoleAccess, accessRoles))

  if (!userHasAccess) {
    return <Forbidden />
  }

  return <>{children}</>
}

export default AolAccess
